import { capitalizeFirstLetter } from '.'

export function platformsDTO(platforms) {
  return platforms.map(platform => {
    switch (platform) {
      case 'ios':
      case 'wp':
        return platform.toUpperCase()
      default:
        return capitalizeFirstLetter(platform)
    }
  })
}
